import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const Medications = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Medicamentos'}
            horizontal={true}
            subtitles={chartData?.medications?.map((item) => item.description)}
            values={chartData?.medications?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
